
  <div class="contenedor">
    <div class="fila">
        <img *ngIf="true" [class.parpadeo]="isChecked" src="../../../assets/icons/bocina.svg" alt="persona-con-balaclava" class="symbol-icon">
    </div>
    <div class="fila">
        <mat-slide-toggle [(ngModel)]="isChecked" class="big-toggle custom-toggle"></mat-slide-toggle>

    </div>
  </div>